[
  {
    "id": "flappy-bee",
    "title": "Flappy Bee",
    "summary": "Flap through the desert. Don't kiss the cactus.",
    "status": "playable",
    "launch": { "mode": "iframe", "src": "./games/flappy-bee/index.html" },
    "controls": "Click the game, then click / tap / space to flap. Exit game to leave."
  },
  {
    "id": "5-tries",
    "title": "5-Tries",
    "summary": "Five letters. Five guesses. A daily word puzzle.",
    "status": "playable",
    "launch": { "mode": "iframe", "src": "./games/5-tries/index.html" },
    "controls": "Type or tap letters, Enter to guess, Backspace to erase. New daily puzzle at midnight; Practice mode anytime."
  }
]
